module.exports = __webpack_public_path__ + "static/media/ky.b7acd796.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ky.svg
// module id = 866
// module chunks = 0